import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Input = styled(TextFieldMui)`
  margin: 0 !important;
  height: 2.3rem;
`

export const EntryForm = styled.form` 
  margin: 0;
`

export const InputContainer = styled.div` 
  display: grid; 
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr; 
  grid-template-rows: 50px; 
  gap: 16px; 
  margin-top: 1.2em;
  height: 3rem;
`

export const ButtonSubmit = styled(ButtonMui)`
  width: 11rem;
  height: 2.3rem;
  margin: 0 !important;
`
